export default __webpack_public_path__ + "static/media/ondemand_deactive.9b4eaa7d.svg";